import Spacer from "./styled";

export default Spacer;
